
export const api = {
  'test': 'https://todo-pc-sit-usa.platanus.com',
  'dev': 'https://todo-pc-dev.platanus.com',
  'uat': 'https://todo-pc-uat.platanus.com',
  'pre': 'https://todo-pc-pre.platanus.com',
  'prd': 'https://todo-pc-usa.platanus.com'
}

export const env = getEnv()

function getEnv() {
  let env = 'init'
  let href = window.location.href || ''
  if (
    href.includes('localhost') ||
    href.includes('127.0.0.1') ||
    href.includes('//todo-pc-sit-usa.platanus.com')
  ) {
    env = 'test'
  } else if (href.includes('//todo-pc-uat.platanus.com')) {
    env = 'uat'
  } else if (href.includes('//todo-pc-pre.platanus.com')) {
    env = 'pre'
  }
  else if (href.includes('//todo-pc-usa.platanus.com')) {
    env = 'prd'
  }  
  else if (href.includes('//todo-pc-dev.platanus.com')) {
    env = 'dev'
  }
  console.log('environment:', env)
  return env
}
